import * as api from "api/api";

export const getUploadSignature = (uploadPreset: string) => {
	return api.getUploadSignature(uploadPreset);
};
